import { useTypedParams } from '@sorare/routing';

import { RewardsFixtureLayout } from 'layouts/rewards/RewardsFixtureLayout';

import type { LayoutParams } from './__generated__/routeParams';

const RewardsFixtureLayoutPage = () => {
  const { fixture, league, quality, rarity } = useTypedParams<LayoutParams>();
  return (
    <RewardsFixtureLayout
      fixture={fixture}
      league={league}
      quality={quality}
      rarity={rarity}
    />
  );
};

export default RewardsFixtureLayoutPage;
